import {
  Action_GetDMStore,
  Action_GetDMStoreSuccess,
  Action_GetDMCategories,
  Action_GetDMCategoriesSuccess,
  Action_GetDMCategories1,
  Action_GetDMCategoriesSuccess1,
  Action_GetDMCategoriesBaoGia,
  Action_GetDMCategoriesBaoGiaSuccess,
  Action_GetDMGroupCustomers,
  Action_GetDMGroupCustomersSuccess,
  Action_GetDMBank,
  Action_GetDMBankSuccess,
  Action_GetConfigByKey,
  Action_GetConfigByKeySuccess,
  Action_GetConfigAllSTKey,
  Action_GetConfigAllSTKeySuccess,
  Action_GetThongTinFormIn,
  Action_GetThongTinFormInSuccess
} from "actions/DanhMuc/actionTypes";

const initialState = {
  objDataGroupCategories: {},
  objDataStore: { List: [] },
  objDataCategory: { List: [] },
  objDataCategoryBaoGia: { List: [] },
  objDataGroupCustomer: {},
  isSaveOk: false,
  disabledKhachHangClick: false,
  objDataBank: { List: [] },
  isOkGetDMKhachHang: false,
  objCustomer: {},
  objConfig: {},
  thongTinFromIn: {},
  objConfigAll: { List: [] },
};
// danh mục  ConfigAll
const Reducer_GetConfigAll = (state, action) => ({
  ...state,
});
const Reducer_GetConfigAllSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objConfigAll: action.payload,
  };
};
// danh mục  Config
const Reducer_GetConfigByKey = (state, action) => ({
  ...state,
});
const Reducer_GetConfigByKeySuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objConfig: action.payload,
  };
};
// danh mục group Store
const Reducer_GetDMStore = (state, action) => ({
  ...state,
});
const Reducer_GetDMStoreSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataStore: action.payload,
  };
};
// danh mục category
const Reducer_GetDMCategories = (state, action) => ({
  ...state,
});
const Reducer_GetDMCategoriesSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataCategory: action.payload,
  };
};

const Reducer_GetDMCategories1 = (state, action) => ({
  ...state,
});
const Reducer_GetDMCategoriesSuccess1 = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataCategory: action.payload,
  };
};

const Reducer_GetDMCategoriesBaoGia = (state, action) => ({
  ...state,
});
const Reducer_GetDMCategoriesBaoGiaSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataCategoryBaoGia: action.payload,
  };
};
// danh mục banks
const Reducer_GetDMBank = (state, action) => ({
  ...state,
});
const Reducer_GetDMBankSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataBank: action.payload,
  };
};
// danh mục group Customers
const Reducer_GetDMGroupCustomers = (state, action) => ({
  ...state,
});
const Reducer_GetDMGroupCustomersSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataGroupCustomer: action.payload,
  };
};
// thông tin forrm in
const Reducer_GetThongTinFormIn = (state, action) => ({
  ...state,
});
const Reducer_GetThongTinFormInSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    thongTinFromIn: action.payload,
  };
};
/// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetDMStore:
      return Reducer_GetDMStore(state, action);
    case Action_GetDMStoreSuccess:
      return Reducer_GetDMStoreSuccess(state, action);

    case Action_GetDMCategories:
      return Reducer_GetDMCategories(state, action);
    case Action_GetDMCategoriesSuccess:
      return Reducer_GetDMCategoriesSuccess(state, action);

      case Action_GetDMCategories1:
        return Reducer_GetDMCategories1(state, action);
      case Action_GetDMCategoriesSuccess1:
        return Reducer_GetDMCategoriesSuccess1(state, action);

    case Action_GetDMCategoriesBaoGia:
      return Reducer_GetDMCategoriesBaoGia(state, action);
    case Action_GetDMCategoriesBaoGiaSuccess:
      return Reducer_GetDMCategoriesBaoGiaSuccess(state, action);

    case Action_GetDMGroupCustomers:
      return Reducer_GetDMGroupCustomers(state, action);
    case Action_GetDMGroupCustomersSuccess:
      return Reducer_GetDMGroupCustomersSuccess(state, action);

    case Action_GetDMBank:
      return Reducer_GetDMBank(state, action);
    case Action_GetDMBankSuccess:
      return Reducer_GetDMBankSuccess(state, action);

    case Action_GetConfigByKey:
      return Reducer_GetConfigByKey(state, action);
    case Action_GetConfigByKeySuccess:
      return Reducer_GetConfigByKeySuccess(state, action);

    case Action_GetConfigAllSTKey:
      return Reducer_GetConfigAll(state, action);
    case Action_GetConfigAllSTKeySuccess:
      return Reducer_GetConfigAllSuccess(state, action);

      case Action_GetThongTinFormIn:
        return Reducer_GetThongTinFormIn(state, action);
      case Action_GetThongTinFormInSuccess:
        return Reducer_GetThongTinFormInSuccess(state, action);


    default:
      return state;
  }
};

export default authReducer;
